import React, { memo, useEffect, useRef } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

const KeylessAreaMap = ({
  latitude,
  longitude,
  radius,
  onClick,
}: {
  latitude: number;
  longitude: number;
  radius: number;
  onClick: (e: google.maps.MapMouseEvent) => void;
}) => {
  const mapRef = useRef<google.maps.Map | null>(null);
  const circleRef = useRef<google.maps.Circle | null>(null)

  const updateZoom = (map: any, circle: any) => {
    const bounds = circle.getBounds();
    if (bounds) {
      map.fitBounds(bounds);
    }
  }

  useEffect(() => {
    if (mapRef.current) {
      // Update center and radius
      if (circleRef.current) {
        circleRef.current.setCenter({ lat: latitude, lng: longitude });
        circleRef.current.setRadius(radius);
        updateZoom(mapRef.current, circleRef.current);
      }
    }
  }, [latitude, longitude, radius]);

  const onLoad = (map: google.maps.Map) => {
    mapRef.current = map;

    //After map creation, create the circle
    circleRef.current ??= new google.maps.Circle({
      map: mapRef.current,
      center: { lat: latitude, lng: longitude },
      radius: radius,
      fillColor: "#FF0000",
      fillOpacity: 0.2,
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
    });
    updateZoom(mapRef.current, circleRef.current);
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_APY_KEY_DEV!
  });

  return (
    <div>
      {isLoaded &&
        <GoogleMap
          onLoad={onLoad}
          mapContainerStyle={{
            width: "100%",
            height: "50vh",
            borderRadius: "20px",
          }}
          center={{ lat: latitude, lng: longitude }}
          zoom={13}
          onClick={onClick}
          options={{
            disableDefaultUI: true,
            draggable: true,
            scrollwheel: true,
            disableDoubleClickZoom: true,
            keyboardShortcuts: false,
          }}
        />
      }
    </div>
  );
};

export default memo(KeylessAreaMap);
